module.exports = __webpack_public_path__ + "static/media/wasteland.997cdc2a.jpg";